// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"263bed83","239":"0fd01252","455":"7e93b04a"}[chunkId] + ".chunk.js";
};